import * as React from "react";
import styled from "styled-components";
import { Collapse } from "@mantine/core";
import useDisclosure from "util/hooks/useDisclosure";
import Icon from "./Icon";
const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacings.md};
`;
const Toggle = styled.button`
  background: none;
  border: none;
  padding: ${({ theme }) => theme.spacings.xxs} 0;
  cursor: pointer;
  font-size: inherit;
  color: inherit;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacings.xs};
`;
const Collapsible = ({ label, children, defaultOpen = false }) => {
  const [opened, { toggle }] = useDisclosure(defaultOpen);
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Toggle, { type: "button", onClick: toggle, "aria-expanded": opened }, /* @__PURE__ */ React.createElement(Icon, { name: opened ? "keyboard_arrow_down" : "chevron_right" }), label), /* @__PURE__ */ React.createElement(Collapse, { in: opened }, children));
};
export default Collapsible;
